export const GET_DASHBOARD_SELECT_RESPONSIBLE_BOX = 'GET_DASHBOARD_SELECT_RESPONSIBLE_BOX';
export const LOADING_DASHBOARD_SELECT_RESPONSIBLE_BOX = 'LOADING_DASHBOARD_SELECT_RESPONSIBLE_BOX';
export const DASHBOARD_SELECT_ERROR = 'DASHBOARD_SELECT_ERROR';